import React, { useRef } from 'react'
import openai from '../utils/openAi'
import { lang } from "../utils/LanguageConstants"
import { useDispatch, useSelector } from 'react-redux'
import { API_OPTIONS } from '../utils/Constants'
import {  addGptMovieResult } from "../utils/gptSlice";
  const GptSearchBar = () => {
  const langKey = useSelector((store)=> store.config.lang)
  const searchText = useRef(null);
  const dispatch =  useDispatch();
  
  const searchMovieTMDB = async (movie) =>{
    const data = await fetch("https://api.themoviedb.org/3/search/movie?query=" +
    movie +
    "&include_adult=false&language=en-US&page=1", API_OPTIONS);
    const json = await data.json();
    return json.results;

    
}

const handleGptSearchClick = async ()=>{
  //   const gptQuery =
  // "Act as a Movie Recommendation system and suggest some movies for the query : " +
  // searchText.current.value +
  // ". only give me names of 5 movies, comma seperated like the example result given ahead. Example Result: Gadar, Sholay, Don, Golmaal, Koi Mil Gaya";
  // console.log(searchText.current.value);

  //   const gptResults = await openai.chat.completions.create({
  //     messages: [{ role: 'assistance', content: gptQuery}],
  //     model: 'gpt-3.5-turbo',
  //   });
  //   console.log(gptResults.choices)
  //    if(!gptResults){}
      //ToDO: write Error Handleling
    //  
    const gptResults = "Mission: Impossible - Fallout, Top Gun,  Jerry Maguire,Minority Report,  Edge of Tomorrow";
  //  const gptResults = "Crazy Rich Asians, Silver Linings Playbook, La La Land,Titanic, The Fault in Our Stars, Bridget Jones's Diary, Before Sunrise, A Star Is Born, Love Actually,   Notting Hill";
    const gptmovies = gptResults.split(",");
    console.log(gptmovies) 
    const promiseArray =  gptmovies.map((movie) => searchMovieTMDB(movie));
    console.log(promiseArray) 
    const TMDbResults = await Promise.all(promiseArray);
    console.log(TMDbResults) 
    dispatch(addGptMovieResult({movieNames:gptmovies, moviesResult:TMDbResults}));
    searchText.current.value = "";
    
   }
  
  return (
    <div className='pt-[40%] md:p-8 sm:pt-[30%] md:pt-[10%] flex  justify-center'>
        <form className= 'w-full  md:w-1/2 bg-black grid grid-cols-12' onSubmit={(e)=>e.preventDefault()}>
            <input ref={searchText} type='text' className=' md:p-4 m-4 col-span-9'  placeholder={lang[langKey].gptSearchPlaseholder}/>
            <button  onClick={handleGptSearchClick} className='col-span-3 m-4 py-2 md:px-4 bg-red-700 text-white rounded-lg'>
              {lang[langKey].search}
            </button> 
        </form>
    </div>
  )
}

export default GptSearchBar